module.exports = __webpack_public_path__ + "static/media/SF_bm_engl_sentrert_logo_vestland_pos.c5ac5c92.svg";